import { filter, sortBy } from 'es-toolkit/compat';
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Takes a list of entities that can be archived and also ordered and returns the entities that
 * are not archived and in order based on the ordering property on the entity.
 * @param {Object[]} entities A list of entity proto objects.
 * @returns {Object[]} The non-archived entities in display order.
 */
export function getActiveInOrder(entities: any) {
  let activeEntities = filter(entities as any[], (entity) => !entity.isArchived);

  // Re-order options.
  activeEntities = sortBy(activeEntities, (entity) =>
    entity.ordering === null ? Number.MAX_SAFE_INTEGER : entity.ordering
  );

  // Backfill ordering on options that don't have one.
  activeEntities.forEach((entity, index) => (entity.ordering = index));
  return activeEntities;
}

/**
 * Takes a list of entities that can be archived and returns only the archived ones.
 * @param {Object[]} entities A list of entity proto objects.
 * @returns {Object[]} The archived entities only.
 */
export function getArchived(entities: any) {
  return filter(entities as any[], (entity) => entity.isArchived);
}
